export default "__VITE_ASSET__a3a37dab__"